import * as React from 'react';

import {useGetEmailSequenceContext} from '../graphql/hooks/use-get-email-sequence-context';
import {updateEmailTemplateContext, EMAIL_SEQUENCE_AGENT} from '../helpers';
import {TeamAiAgent} from '../team-ai-agent';

export function EmailSequenceAgent() {
    const {context: sequenceContext} = useGetEmailSequenceContext();

    const onInitializeChatbot = (chatbot: any): void => {
        if (sequenceContext) {
            updateEmailTemplateContext(chatbot, sequenceContext);
        }
    };

    return (
        <TeamAiAgent
            agentKey={EMAIL_SEQUENCE_AGENT}
            onInitializeChatbot={onInitializeChatbot}
            pageContext={null}
        />
    );
}
